<template>
	<v-dialog
		v-model="open"
		max-width="700"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">案件詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="mt-4">
					<h3 class="heading">基本情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">作成日</th>
								<td width="70%">{{ matter.created_at | dateFormatter }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">最終更新日</th>
								<td width="70%">{{ matter.updated_at | dateFormatter }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">案件名</th>
								<td width="70%">{{ matter.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">見積番号</th>
								<td width="70%">{{ matter.quotation_number }}-{{ matter.quotation_sub_number }}</td>
							</tr>

							<tr>
								<th width="30%" class="font-weight-bold">成約したかどうか</th>
								<td v-if="matter.contract == true" width="70%">成約</td>
								<td v-if="matter.contract == false" width="70%">失注</td>
								<td v-if="matter.contract == null" width="70%">未定</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">商品区分(主区分)</th>
								<td>{{ matter.product_category.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">分類区分(副区分)</th>
								<td>{{ matter.product_sub_category.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">チーム</th>
								<td width="70%">{{ matter.team ? matter.team.name : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">本件の担当者</th>
								<td width="70%">{{ matter.team_member_name ? matter.team_member_name : "" }}</td>
							</tr>

							<tr>
								<th width="30%" class="font-weight-bold">受注確度</th>
								<td width="70%">{{ matter.situation_ja ? matter.situation_ja : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">流れ品か否か</th>
								<td v-if="matter.regularly_sold == true" width="70%">流れ品</td>
								<td v-if="matter.regularly_sold == false" width="70%">否</td>
								<td v-if="matter.regularly_sold == null" width="70%">未設定</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">案件の概要</th>
								<td width="70%">{{ matter.description ? matter.description : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">進捗状況及び契約までのポイント</th>
								<td width="70%">{{ matter.points ? matter.points : "" }}</td>
							</tr>
						</tbody>
					</table>

					<h3 class="heading">顧客情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">得意先</th>
								<td width="70%">
									{{ matter.regular_customer_company ? matter.regular_customer_company.name : "" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">得意先担当者</th>
								<td width="70%">
									{{ matter.regular_customer_person ? matter.regular_customer_person.name : "" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">エンドユーザー</th>
								<td width="70%">
									{{ matter.customer_company ? matter.customer_company.name : "" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">エンドユーザー担当者</th>
								<td width="70%">{{ matter.customer_person ? matter.customer_person.name : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">商流</th>
								<td id="distribution_channels" width="70%">
									<p class="font-weight-bold white-space-nomal">
										{{ currentCompanyName ? currentCompanyName : "当社" }}
									</p>
									<span>→</span
									>{{ matter.customer_company_01 ? matter.customer_company_01.name : "" }}<br />
									<span v-if="matter.customer_company_02">→</span
									>{{ matter.customer_company_02 ? matter.customer_company_02.name : ""
									}}<br v-show="matter.customer_company_02" />
									<span v-if="matter.customer_company_03">→</span
									>{{ matter.customer_company_03 ? matter.customer_company_03.name : ""
									}}<br v-show="matter.customer_company_03" />
									<span v-if="matter.customer_company_04">→</span>
									{{ matter.customer_company_04 ? matter.customer_company_04.name : ""
									}}<br v-show="matter.customer_company_04" />
									<span v-if="matter.customer_company_05">→</span
									>{{ matter.customer_company_05 ? matter.customer_company_05.name : ""
									}}<br v-show="matter.customer_company_05" />
									<span v-if="matter.customer_company_06">→</span
									>{{ matter.customer_company_06 ? matter.customer_company_06.name : ""
									}}<br v-show="matter.customer_company_06" />
									<span v-if="matter.customer_company_07">→</span
									>{{ matter.customer_company_07 ? matter.customer_company_07.name : ""
									}}<br v-show="matter.customer_company_07" />
									<span v-if="matter.customer_company_08">→</span
									>{{ matter.customer_company_08 ? matter.customer_company_08.name : ""
									}}<br v-show="matter.customer_company_08" />
									<span v-if="matter.customer_company_09">→</span
									>{{ matter.customer_company_09 ? matter.customer_company_09.name : ""
									}}<br v-show="matter.customer_company_09" />
								</td>
							</tr>
						</tbody>
					</table>

					<h3 class="heading">時期情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">見積納期（見込納期）</th>
								<td width="70%">{{ matter.quotation_deadline ? quotationDeadline : "" }}</td>
							</tr>
							<tr>
								<th v-if="matter.contract" width="30%" class="font-weight-bold">
									実納期（受注時）
								</th>
								<td v-if="matter.contract" width="70%">{{ matter.deadline ? deadline : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">見積提出日</th>
								<td width="70%">
									{{ matter.quotation_submission_date ? quotationSubmissionDate : "" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">受注見込日</th>
								<td width="70%">{{ matter.planned_order_date ? plannedOrderDate : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">受注/失注　決算期</th>
								<td width="70%">{{ matter.company_period ? matter.company_period.title : "" }}</td>
							</tr>
							<tr>
								<th v-if="matter.contract" width="30%" class="font-weight-bold">受注日</th>
								<td v-if="matter.contract" width="70%">{{ matter.order_date ? orderDate : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">原価計算依頼日</th>
								<td width="70%">{{ matter.costing_request_date ? costingRequestDate : "" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">原価受領日</th>
								<td width="70%">{{ matter.cost_receipt_date ? costReceiptDate : "" }}</td>
							</tr>
						</tbody>
					</table>

					<h3 class="heading">競合・失注情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">競合先</th>
								<td width="70%">{{ matter.competitor ? matter.competitor : "" }}</td>
							</tr>
							<tr>
								<th
									v-if="!matter.contract && matter.contract !== null"
									width="30%"
									class="font-weight-bold"
								>
									失注先
								</th>
								<td v-if="!matter.contract && matter.contract !== null" width="70%">
									{{ matter.lost_to ? matter.lost_to : "" }}
								</td>
							</tr>
							<tr>
								<th
									v-if="!matter.contract && matter.contract !== null"
									width="30%"
									class="font-weight-bold"
								>
									失注理由
								</th>
								<td v-if="!matter.contract && matter.contract !== null" width="70%">
									{{ matter.lost_reason ? matter.lost_reason : "" }}
								</td>
							</tr>
						</tbody>
					</table>

					<h3 class="heading">金額情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">総原価</th>
								<td width="70%">
									{{ matter.total_cost ? Number(matter.total_cost).toLocaleString() + "円" : "" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">見積額（総額）</th>
								<td width="70%">
									{{
										matter.quotation_amount
											? Number(matter.quotation_amount).toLocaleString() + "円"
											: ""
									}}
								</td>
							</tr>
							<tr>
								<th v-if="matter.contract" width="30%" class="font-weight-bold">受注額</th>
								<td v-if="matter.contract" width="70%">
									{{
										matter.ordered_amount
											? Number(matter.ordered_amount).toLocaleString() + "円"
											: ""
									}}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">粗利</th>
								<td width="70%">
									{{
										matter.ordered_amount && matter.total_cost
											? grossProfit.toLocaleString() + "円"
											: ""
									}}
								</td>
							</tr>
							<tr>
								<th
									v-if="!matter.contract && matter.contract !== null"
									width="30%"
									class="font-weight-bold"
								>
									失注額
								</th>
								<td
									v-if="!matter.contract && matter.contract !== null"
									id="lost_amount"
									width="70%"
								>
									{{ matter.lost_amount ? Number(matter.lost_amount).toLocaleString() + "円" : "" }}
								</td>
							</tr>
						</tbody>
					</table>

					<h3 class="heading">詳細情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr v-for="matter_value in matter.matter_values" :key="matter_value.id">
								<th width="30%" class="font-weight-bold mb-1">
									{{ matter_value.matter_key.name }}
								</th>
								<td width="70%">{{ matter_value.value }}</td>
							</tr>
						</tbody>
					</table>

					<!-- matter_product-->
					<h3 v-if="matter.matter_products && matter.matter_products.length !== 0" class="heading">
						製品情報
					</h3>
					<table
						width="100%"
						class="show-dialog-table mb-1"
						v-for="matter_product in matter.matter_products"
						:key="matter_product.id"
					>
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">製品名</th>
								<td width="70%">{{ matter_product.product.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">サブネーム</th>
								<td width="70%">{{ matter_product.sub_name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">単価</th>
								<td width="70%">{{ Number(matter_product.unit_price).toLocaleString() + "円" }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">数量</th>
								<td width="70%">{{ matter_product.quantity }}</td>
							</tr>
						</tbody>
					</table>

					<!-- ordered_product-->
					<h3
						v-if="matter.ordered_products && matter.ordered_products.length !== 0"
						class="heading"
					>
						注文製品情報
					</h3>
					<table
						width="100%"
						class="show-dialog-table mb-1"
						v-for="ordered_product in matter.ordered_products"
						:key="ordered_product.id"
					>
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">製造番号</th>
								<td width="70%">{{ ordered_product.product_number }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">サブネーム</th>
								<td width="70%">{{ ordered_product.sub_name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">単価</th>
								<td width="70%">
									{{ Number(ordered_product.unit_price).toLocaleString() + "円" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">数量</th>
								<td width="70%">{{ ordered_product.quantity }}</td>
							</tr>
						</tbody>
					</table>
					<v-row no-gutters class="my-4 pb-4" justify="start">
						<v-btn dark outlined @click="openMatterFileIndexDialog()" color="secondary">
							<v-icon>mdi-paperclip</v-icon> 案件添付ファイル一覧
						</v-btn>
					</v-row>
					<MatterFileIndexDialog
						:id="matter.id"
						v-if="MatterFileIndexDialogFlag"
						@close="MatterFileIndexDialogFlag = false"
					/>
				</v-sheet>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="8" />
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="$emit('close')"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
			<MatterAcceptanceInspectionDialog
				:matter="matter"
				:dialog.sync="acceptanceInspectionDialog"
			/>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import MatterFileIndexDialog from "../../shared/MatterFileIndexDialog.vue"
import MatterAcceptanceInspectionDialog from "./MatterAcceptanceInspectionDialog.vue"

export default {
	components: {
		MatterFileIndexDialog,
		MatterAcceptanceInspectionDialog,
	},
	props: {
		matter_data: {
			type: Object,
			required: false,
			default: () => {},
		},
		current_company_name: {
			type: String,
			required: false,
		},
		requiredFetch: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
		text: Boolean,
	},
	data() {
		return {
			open: true,
			currentCompanyName: null,
			matter: {
				created_at: null,
				updated_at: null,
				name: null,
				quotation_number: null,
				quotation_sub_number: null,
				contract: null,
				product_category: {},
				product_sub_category: {},
				team: null,
				team_member_name: null,
				situation_ja: null,
				regularly_sold: null,
				description: null,
				points: null,
				regular_customer_company: {},
				regular_customer_person: {},
				customer_company: {},
				customer_person: {},
				customer_company_01: {},
				customer_company_02: {},
				customer_company_03: {},
				customer_company_04: {},
				customer_company_05: {},
				customer_company_06: {},
				customer_company_07: {},
				customer_company_08: {},
				customer_company_09: {},
				quotation_deadline: null,
				deadline: null,
				quotation_submission_date: null,
				planned_order_date: null,
				company_period: {},
				order_date: null,
				costing_request_date: null,
				cost_receipt_date: null,
				competitor: null,
				lost_to: null,
				lost_reason: null,
				total_cost: null,
				quotation_amount: null,
				ordered_amount: null,
				lost_amount: null,
				matter_values: [],
				matter_products: [],
				ordered_products: [],
				total_cost: null,
			},
			acceptanceInspectionDialog: true,
			MatterFileIndexDialogFlag: false,
			common,
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		if (this.requiredFetch && this.id) {
			this.fetchMatter(this.id)
		} else {
			this.matter = this.matter_data
			this.currentCompanyName = this.current_company_name
		}
	},
	methods: {
		openMatterFileIndexDialog() {
			this.MatterFileIndexDialogFlag = true
		},
		fetchMatter(id) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/matters/${id}`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					this.matter = res.data.matter
					this.currentCompanyName = res.data.current_company_name
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		grossProfit() {
			return Number(this.matter.ordered_amount - this.matter.total_cost)
		},
		quotationDeadline() {
			return moment(this.matter.quotation_deadline).format("YYYY/MM/DD")
		},
		quotationSubmissionDate() {
			return moment(this.matter.quotation_submission_date).format("YYYY/MM/DD")
		},
		plannedOrderDate() {
			return moment(this.matter.planned_order_date).format("YYYY/MM/DD")
		},
		orderDate() {
			return moment(this.matter.order_date).format("YYYY/MM/DD")
		},
		costingRequestDate() {
			return moment(this.matter.costing_request_date).format("YYYY/MM/DD")
		},
		costReceiptDate() {
			return moment(this.matter.cost_receipt_date).format("YYYY/MM/DD")
		},
		deadline() {
			return moment(this.matter.deadline).format("YYYY/MM/DD")
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.fetchMatter(newVal)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
table {
	table-layout: fixed;
}

h3.heading {
	font-size: 105%;
	font-weight: bold;
	color: white;
	background: $main-color;
	margin: 32px 0 0 0;
	padding: 8px;
}
.white-space-nomal {
	white-space: normal !important;
}
</style>
